import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SinkState } from './sink.types';

import { SINK_OPTIONS } from '~/core/enums';
import { ApplianceModel } from '~/core/models';
import { SelectedSinksAmount } from '~/core/types/appliances';

const initialState: SinkState = {
  selectedSinkProductId: undefined,
  selectedSinks: [],
  isFilterExpanded: false,
  inStoreSinksUrl: '',
  selectedBrowsingOption: SINK_OPTIONS.BROWSE_SINKS,
};

const sinkSlice = createSlice({
  name: 'sink',
  initialState,
  reducers: {
    resetSelectedBrowsingOption: (state) => {
      state.selectedBrowsingOption = initialState.selectedBrowsingOption;
    },
    resetSelectedSink: (state) => {
      state.selectedSinkProductId = initialState.selectedSinkProductId;
    },
    updateSelectedSinkProductId: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.selectedSinkProductId = action.payload;
    },
    updateSelectedBrowsingOption: (
      state,
      action: PayloadAction<SINK_OPTIONS>
    ) => {
      state.selectedBrowsingOption = action.payload;
    },
    resetAllSinkQuantities: (state) => {
      state.selectedSinks = initialState.selectedSinks;
    },
    setSelectedSinks: (state, action: PayloadAction<SelectedSinksAmount>) => {
      state.selectedSinks = [...action.payload];
    },
    updateInStoreSinksUrl: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      if (action.payload) {
        state.inStoreSinksUrl = action.payload;
      }
    },
    increaseSinkQuantity: (
      state,
      action: PayloadAction<{
        id: ApplianceModel['productId'];
        hasChipMinimizer?: boolean;
      }>
    ) => {
      state.selectedSinks = [...state.selectedSinks, action.payload];
    },
    decreaseSinkQuantity: (
      state,
      action: PayloadAction<ApplianceModel['productId']>
    ) => {
      // Find the last sink added with that id
      const index = state.selectedSinks.findLastIndex(
        (sink) => sink.id === action.payload
      );

      // Remove that sink if it exists
      if (index !== -1) {
        state.selectedSinks.splice(index, 1);
      }
    },
    clearChipMinimizerFlags: (state) => {
      state.selectedSinks = state.selectedSinks.map((sink) => ({
        ...sink,
        hasChipMinimizer: false,
      }));
    },
  },
});

export const {
  resetSelectedBrowsingOption,
  resetSelectedSink,
  updateSelectedBrowsingOption,
  updateSelectedSinkProductId,
  resetAllSinkQuantities,
  setSelectedSinks,
  updateInStoreSinksUrl,
  increaseSinkQuantity,
  decreaseSinkQuantity,
  clearChipMinimizerFlags,
} = sinkSlice.actions;

export default sinkSlice.reducer;
